const SkeletonBlock = ({ className }: { className: string }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

export const NotificationSkeleton = () => {
  return (
    <div className="border p-4 rounded-xl bg-white shadow border-gray-200">
      <div className="flex justify-between items-start mb-2">
        <SkeletonBlock className="h-6 w-48" />
        <SkeletonBlock className="h-5 w-12 rounded-full" />
      </div>
      <SkeletonBlock className="h-4 w-full mb-1" />
      <SkeletonBlock className="h-4 w-3/4 mb-2" />
      <SkeletonBlock className="h-3 w-32" />
    </div>
  );
};

export const NotificationSkeletonList = ({ count = 5 }: { count?: number }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, index) => (
        <NotificationSkeleton key={index} />
      ))}
    </div>
  );
};
